import React, { useEffect, useState, useRef, useCallback } from "react";
import { Stack } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../context/global";
import MultiSelect from "../../components/DropDown/Multiselect";
import { masterApi } from "../../apis/masterApi";
import { encodeData } from "../../helper/common/encodeData";

const FILTER_SEARCH_DEBOUNCE_MS = 400;
const FILTER_FETCH_LIMIT = 500;

const ReportFilters = (props) => {
  const [campaignType, setCampaignType] = useState([]);
  const [campaignFormat, setCampaignFormat] = useState([]);
  const [targetingType, setTargetingType] = useState([]);
  const [productSet, setProductSet] = useState([]);
  const [campaignStatus, setCampaignStatus] = useState([]);
  const [portfolioName, setPortfolioName] = useState([]);
  const [categoryName, setCategoryName] = useState([]);
  const [campaignName, setCampaignName] = useState([]);
  const [adStatus, setAdStatus] = useState([]);
  const [targetStatus, setTargetStatus] = useState([]);
  const [adgroupStatus, setAdgroupStatus] = useState([]);
  const [placement, setPlacement] = useState([]);
  const [portfolioNameFilter, setPortfolioNameFilter] = useState([]);
  const [campaignNameFilter, setCampaignNameFilter] = useState([]);
  const [categoryNameFilter, setCategoryNameFilter] = useState([]);
  const [productSetFilter, setProductSetFilter] = useState([]);
  const [defaultDropdown, setDefaultDropdown] = useState(props.selected ?? []);
  const [adyogiMatchtype, setAdyogiMatchtype] = useState([]);
  const [portfolioData, setPortfolioData] = useState([]);
  const { clientId } = useGlobalContext();
  const isBackendPortfolio = props.backendSearchFilters?.includes("Portfolio Name");
  const isBackendProductSet = props.backendSearchFilters?.includes("Product Set");

  const [portfolioSearchInput, setPortfolioSearchInput] = useState("");
  const [debouncedPortfolioSearch, setDebouncedPortfolioSearch] = useState(null);
  const [portfolioFetchKey, setPortfolioFetchKey] = useState(0);
  const [isLoadingPortfolioOptions, setIsLoadingPortfolioOptions] = useState(false);
  const [hasPortfolioSearchFetched, setHasPortfolioSearchFetched] = useState(false);
  const portfolioSearchDebounceRef = useRef(null);
  const portfolioFetchRequestIdRef = useRef(0);
  const lastDebouncedPortfolioRef = useRef(null);

  const [productSetSearchInput, setProductSetSearchInput] = useState("");
  const [debouncedProductSetSearch, setDebouncedProductSetSearch] = useState(null);
  const [productSetFetchKey, setProductSetFetchKey] = useState(0);
  const [isLoadingProductSetOptions, setIsLoadingProductSetOptions] = useState(false);
  const [hasProductSetSearchFetched, setHasProductSetSearchFetched] = useState(false);
  const productSetSearchDebounceRef = useRef(null);
  const productSetFetchRequestIdRef = useRef(0);
  const lastDebouncedProductSetRef = useRef(null);

  const normalizeFilterTypeForState = (type) => {
    const raw = String(type ?? "");
    const withoutDimension = raw.endsWith("Dimension")
      ? raw.slice(0, -"Dimension".length)
      : raw;
    if (withoutDimension === "portfolioId" || withoutDimension === "portfolio_id") {
      return "portfolioName";
    }
    return withoutDimension;
  };

  const handleApply = (e, type) => {
    props.handleDropdown(e, type);
    const normalizedType = normalizeFilterTypeForState(type);
    if (normalizedType === "campaignType") {
      setCampaignType(e);
    } else if (normalizedType === "campaignFormat") {
      setCampaignFormat(e);
    } else if (normalizedType === "targetingType") {
      setTargetingType(e);
    } else if (normalizedType === "productSet") {
      setProductSet(e);
    } else if (normalizedType === "campaignStatus") {
      setCampaignStatus(e);
    } else if (normalizedType === "portfolioName") {
      setPortfolioName(e);
    } else if (normalizedType === "adStatus") {
      setAdStatus(e);
    } else if (normalizedType === "category") {
      setCategoryName(e);
    } else if (normalizedType === "campaignName") {
      setCampaignName(e);
    } else if (normalizedType === "targetStatus") {
      setTargetStatus(e);
    } else if (normalizedType === "placement") {
      setPlacement(e);
    } else if (normalizedType === "defaultDropdown") {
      setDefaultDropdown(e);
    } else if (normalizedType === "adgroupStatus") {
      setAdgroupStatus(e)
    } else if (normalizedType === "adyogiTargetingType") {
      setAdyogiMatchtype(e)
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
// Log the values to the console
    const stateSetters = convertArray(props.enabledfilters);
    stateSetters.forEach((value) => {
      if(value === "categoryNames"){
        value = "category";
      }
      if(value === "campaignNames") {
        value = "campaignName"
      }
      if (queryParams.get(value)) {
        handleApply(queryParams.get(value).split(","), value);
      }
    });
  //  props.handleDropdown({},queryParamsObject,true)
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (!queryParams.get("portfolio_id") || !clientId) return undefined;

    if (isBackendPortfolio) {
      const portfolioIds = queryParams.get("portfolio_id").split(",");
      masterApi(
        {
          source: "amazon",
          fields: "name,platform_id",
          limit: portfolioIds.length,
          filtering: encodeData([
            {
              field_name: "platform_id",
              operator: "IN",
              values: portfolioIds,
            },
          ]),
        },
        "getPortfolios",
        false
      ).then((response) => {
        const names =
          response?.data?.data?.map((item) => item?.name)?.filter(Boolean) ?? [];
        if (names.length) {
          handleApply(names, "portfolioName");
        }
        setPortfolioData(response?.data?.data ?? []);
      });
      return undefined;
    }

    if (portfolioData?.length > 0) {
      const portfolioIds = queryParams.get("portfolio_id").split(",");
      const names = portfolioData
        .filter((item) =>
          portfolioIds.includes(item?.platform_id?.toString())
        )
        ?.map((item) => item.name);
      handleApply(names, "portfolioName");
    }
  }, [portfolioData, clientId, isBackendPortfolio]);

  useEffect(() => {
    if (!isBackendPortfolio) return undefined;

    if (portfolioSearchDebounceRef.current) {
      clearTimeout(portfolioSearchDebounceRef.current);
    }

    portfolioSearchDebounceRef.current = setTimeout(() => {
      const effectiveTerm = portfolioSearchInput.trim();
      if (effectiveTerm === lastDebouncedPortfolioRef.current) {
        return;
      }
      lastDebouncedPortfolioRef.current = effectiveTerm;
      setDebouncedPortfolioSearch(effectiveTerm);
    }, FILTER_SEARCH_DEBOUNCE_MS);

    return () => {
      if (portfolioSearchDebounceRef.current) {
        clearTimeout(portfolioSearchDebounceRef.current);
      }
    };
  }, [portfolioSearchInput, isBackendPortfolio]);

  useEffect(() => {
    if (!isBackendProductSet) return undefined;

    if (productSetSearchDebounceRef.current) {
      clearTimeout(productSetSearchDebounceRef.current);
    }

    productSetSearchDebounceRef.current = setTimeout(() => {
      const effectiveTerm = productSetSearchInput.trim();
      if (effectiveTerm === lastDebouncedProductSetRef.current) {
        return;
      }
      lastDebouncedProductSetRef.current = effectiveTerm;
      setDebouncedProductSetSearch(effectiveTerm);
    }, FILTER_SEARCH_DEBOUNCE_MS);

    return () => {
      if (productSetSearchDebounceRef.current) {
        clearTimeout(productSetSearchDebounceRef.current);
      }
    };
  }, [productSetSearchInput, isBackendProductSet]);

  useEffect(() => {
    if (!isBackendPortfolio || debouncedPortfolioSearch === null) {
      return undefined;
    }

    let cancelled = false;
    const requestId = portfolioFetchRequestIdRef.current + 1;
    portfolioFetchRequestIdRef.current = requestId;
    setIsLoadingPortfolioOptions(true);

    const loadPortfolioOptions = async () => {
      try {
        const term = debouncedPortfolioSearch.trim();
        const nameFilter = term
          ? [{ field_name: "name", operator: "CONTAINS", value: term }]
          : [];
        const result = await masterApi(
          {
            source: "amazon",
            fields: "name,platform_id",
            limit: FILTER_FETCH_LIMIT,
            ...(nameFilter.length && { filtering: encodeData(nameFilter) }),
          },
          "getPortfolios",
          false
        );

        if (cancelled || portfolioFetchRequestIdRef.current !== requestId) {
          return;
        }

        const portfolios = result?.data?.data ?? [];
        setPortfolioData(portfolios);
        setPortfolioNameFilter(
          portfolios.map((item) => item?.name)?.filter(Boolean)
        );
        setHasPortfolioSearchFetched(true);
        setIsLoadingPortfolioOptions(false);
      } catch (error) {
        if (!cancelled && portfolioFetchRequestIdRef.current === requestId) {
          toast.error("Failed to fetch portfolios");
          setHasPortfolioSearchFetched(true);
          setIsLoadingPortfolioOptions(false);
        }
      }
    };

    loadPortfolioOptions();

    return () => {
      cancelled = true;
    };
  }, [debouncedPortfolioSearch, portfolioFetchKey, isBackendPortfolio]);

  useEffect(() => {
    if (!isBackendProductSet || debouncedProductSetSearch === null) {
      return undefined;
    }

    let cancelled = false;
    const requestId = productSetFetchRequestIdRef.current + 1;
    productSetFetchRequestIdRef.current = requestId;
    setIsLoadingProductSetOptions(true);

    const loadProductSetOptions = async () => {
      try {
        const term = debouncedProductSetSearch.trim();
        const nameFilter = term
          ? [{ field_name: "product_set", operator: "CONTAINS", value: term }]
          : [];
        const result = await masterApi(
          {
            source: "amazon",
            limit: FILTER_FETCH_LIMIT,
            ...(nameFilter.length && { filtering: encodeData(nameFilter) }),
          },
          "getProductSetFilter",
          false
        );

        if (cancelled || productSetFetchRequestIdRef.current !== requestId) {
          return;
        }

        const productSets =
          result?.data?.data
            ?.map((item) => item?.product_set)
            ?.filter(Boolean) ?? [];
        setProductSetFilter(productSets);
        setHasProductSetSearchFetched(true);
        setIsLoadingProductSetOptions(false);
      } catch (error) {
        if (!cancelled && productSetFetchRequestIdRef.current === requestId) {
          toast.error("Failed to fetch product sets");
          setHasProductSetSearchFetched(true);
          setIsLoadingProductSetOptions(false);
        }
      }
    };

    loadProductSetOptions();

    return () => {
      cancelled = true;
    };
  }, [debouncedProductSetSearch, productSetFetchKey, isBackendProductSet]);

  const handlePortfolioSearchInput = useCallback((value) => {
    setPortfolioSearchInput(value);
  }, []);

  const handleProductSetSearchInput = useCallback((value) => {
    setProductSetSearchInput(value);
  }, []);

  const handlePortfolioDropdownOpen = useCallback(() => {
    lastDebouncedPortfolioRef.current = null;
    setPortfolioSearchInput("");
    setDebouncedPortfolioSearch("");
    setHasPortfolioSearchFetched(false);
    setPortfolioNameFilter([]);
    setPortfolioFetchKey((key) => key + 1);
  }, []);

  const handleProductSetDropdownOpen = useCallback(() => {
    lastDebouncedProductSetRef.current = null;
    setProductSetSearchInput("");
    setDebouncedProductSetSearch("");
    setHasProductSetSearchFetched(false);
    setProductSetFilter([]);
    setProductSetFetchKey((key) => key + 1);
  }, []);

  function convertArray(arr) {
    return arr.map((str) => {
      let words = str.split(" ");
      words = words.map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word[0].toUpperCase() + word.slice(1).toLowerCase()
      );
      return words.join("");
    });
  }

  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "",
      headers: {},
    };
    if (props.enabledfilters.includes("Portfolio Name") && !isBackendPortfolio) {
      config.url =
        "https://adyogiadsapi.adyogi.com/client/" +
        clientId +
        "/portfolios?source=amazon&fields=name,platform_id&limit=10000";
      axios.request(config).then((response) => {
        setPortfolioData(response.data.data ?? []);
        let result = response.data.data.map((item) => item.name);
        setPortfolioNameFilter(result);
      });
    }
    if (props.enabledfilters.includes("Campaign Names")) {
      config.url =
        "https://adyogiadsapi.adyogi.com/client/" +
        clientId +
        "/campaigns?source=amazon&fields=name&limit=100000";
      axios.request(config).then((response) => {
        let result = response.data.data.map((item) => item.name);
        setCampaignNameFilter(result);
      });
    }
    if (props.enabledfilters.includes("Category Names")) {
      config.url =
        "https://catalogapi.adyogi.com/client/" +
        clientId +
        "/categories?source=amazon&fields=name";
      axios.request(config).then((response) => {
        let result = response.data.data.map((item) => item.name);
        setCategoryNameFilter(result);
      });
    }

    if (props.enabledfilters.includes("Product Set") && !isBackendProductSet) {
      config.url =
        "https://adyogiadsapi.adyogi.com/client/" +
        clientId +
        ":product-set?source=amazon";
      axios.request(config).then((response) => {
        let result = response.data.data.map((item) => {
          if (item?.product_set) {
            return item.product_set;
          }
        });
        setProductSetFilter(result);
      });
    }
  }, []);

  const campaignFormatOptions = props?.page === 'product-analytics' ? ["SD", "SP"]  : ["SD", "SP", "SB(V)", "SB"];

  return (
    <>
      <div className="dropdownContentWrapper" style={{ marginBottom: "0px" }}>
        <div className={props.enabledfilters.length > 6 ? "d-flex gap-3 w-100 max-w-100 largeFilters1" : "d-flex gap-3 w-100 max-w-100"}>
          {props.enabledfilters.includes("Category Names") && categoryNameFilter.length > 0 ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Category Names"}
                  options={categoryNameFilter}
                  defaultSelected={categoryName}
                  onApply={(e) => handleApply(e, "category")}
                  label={"Category Names"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Campaign Names")  && campaignNameFilter.length >0 ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  showLimitedOptions={true}
                  limitedOptionsLimit={500}
                  title={"Campaign Name"}
                  options={campaignNameFilter}
                  defaultSelected={campaignName}
                  onApply={(e) => handleApply(e, "campaignNameDimension")}
                  label={"Campaign Name"}
                  isSearch={true}
                  placeHolder={"Search Here..."}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Campaign Type") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Campaign Type"}
                  options={["Retarget", "Prospect"]}
                  defaultSelected={campaignType}
                  onApply={(e) => handleApply(e, "campaignTypeDimension")}
                  label={"Campaign Type"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Campaign Format") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Campaign Format"}
                  options={campaignFormatOptions}
                  defaultSelected={campaignFormat}
                  onApply={(e) => handleApply(e, "campaignFormatDimension")}
                  label={"Campaign Format"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Targeting Type") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Targeting Type"}
                  options={[
                    "G.Keyword",
                    "C.Keyword",
                    "NB.Keyword",
                    "Audience",
                    "Automatic",
                    "NB.Product",
                    "B.Keyword",
                    "B.Audience",
                    "B.Product",
                  ]}
                  defaultSelected={targetingType}
                  onApply={(e) => handleApply(e, "targetingTypeDimension")}
                  label={"Targeting Type"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Adyogi Targeting Type") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Match type"}
                  options={[
                    "Automatic",
                    "Exact",
                    "Broad",
                    "Phrase",
                    "Product",
                    "Audience"
                  ]}
                  defaultSelected={adyogiMatchtype}
                  onApply={(e) => handleApply(e, "adyogiTargetingTypeDimension")}
                  label={"Match type"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Product Set") &&
          (isBackendProductSet || productSetFilter.length > 0) ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Product Set"}
                  options={productSetFilter}
                  defaultSelected={productSet}
                  onApply={(e) => handleApply(e, "productSetDimension")}
                  label={"Product Set"}
                  isSearch={true}
                  placeHolder={"Search Product Set..."}
                  isLoading={isBackendProductSet && isLoadingProductSetOptions}
                  hasFetched={
                    isBackendProductSet ? hasProductSetSearchFetched : undefined
                  }
                  showLimitedOptions={isBackendProductSet}
                  limitedOptionsLimit={500}
                  onSearchInput={
                    isBackendProductSet ? handleProductSetSearchInput : undefined
                  }
                  onDropdownOpen={
                    isBackendProductSet ? handleProductSetDropdownOpen : undefined
                  }
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Campaign Status") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Campaign Status"}
                  options={["enabled", "paused"]}
                  defaultSelected={campaignStatus}
                  onApply={(e) => handleApply(e, "campaignStatusDimension")}
                  label={"Campaign Status"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Ad Status") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Ad Status"}
                  options={["enabled", "paused"]}
                  defaultSelected={adStatus}
                  onApply={(e) => handleApply(e, "adStatus")}
                  label={"Ad Status"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Target Status") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Target Status"}
                  options={["enabled", "paused"]}
                  defaultSelected={targetStatus}
                  onApply={(e) => handleApply(e, "targetStatusDimension")}
                  label={"Target Status"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Adgroup Status") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Ad Group Status"}
                  options={["enabled", "paused","archived"]}
                  defaultSelected={adgroupStatus}
                  onApply={(e) => handleApply(e, "adgroupStatusDimension")}
                  label={"Ad Group Status"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Placement") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Placement"}
                  options={[
                    "Top of Search",
                    "Detail Page on-Amazon",
                    "Other Placements",
                  ]}
                  defaultSelected={placement}
                  onApply={(e) => handleApply(e, "placementDimension")}
                  label={"Placement"}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          {props.enabledfilters.includes("Portfolio Name") &&
          (isBackendPortfolio || portfolioNameFilter.length > 0) ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={"Portfolio Name"}
                  options={portfolioNameFilter}
                  defaultSelected={portfolioName}
                  onApply={(e) => handleApply(e, "portfolioNameDimension")}
                  label={"Portfolio Name"}
                  isSearch={true}
                  placeHolder={"Search Portfolio..."}
                  isLoading={isBackendPortfolio && isLoadingPortfolioOptions}
                  hasFetched={
                    isBackendPortfolio ? hasPortfolioSearchFetched : undefined
                  }
                  showLimitedOptions={isBackendPortfolio}
                  limitedOptionsLimit={500}
                  onSearchInput={
                    isBackendPortfolio ? handlePortfolioSearchInput : undefined
                  }
                  onDropdownOpen={
                    isBackendPortfolio ? handlePortfolioDropdownOpen : undefined
                  }
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
          
          {props.enabledfilters.includes("default") ? (
            <div className="filterItem">
              <Stack gap={4}>
                <MultiSelect
                  title={props.name}
                  options={props.data}
                  defaultSelected={props.defaultDropdown}
                  onApply={(e) => handleApply(e, "defaultDropdown")}
                  isSearch={true}
                  placeHolder={"Search Here..."}
                  classes={" mst-negative-modal-drop-down-height"}
                  label={props.label}
                />
              </Stack>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default ReportFilters;